<template>
    <div role="dialog" class="mobile-toast-popup" :class="{active : visibleBookingLayerPopup}">
        <div class="opacity-bg" @click.prevent="closeBookingController('mobileClose')"></div>
        <div class="toast-layout pc-popup compo-form-item mb-0">

            <!-- 일정 편집 화면 -->
            <template v-if="viewEdit">
                <div class="toast-name">일정변경</div>
                <div class="popup-compo-body">
                    <ShippingDateOption class="mt-0"
                        :visibleBookingLayerPopup="visibleBookingLayerPopup"
                        @checkedWhen="setCheckedWhen"
                        @datetimeLocal="setDatetimeLocal"
                    ></ShippingDateOption>
                    <div class="btns">
                        <button type="button" @click="changeTheSchedule" class="btn-l btn-p">변경</button>
                    </div>
                </div>
            </template>

            <!-- 적용 완료 화면 -->
            <template v-else>
                <div class="popup-compo-body">
                    <div class="result-success">
                        <IconSuccess></IconSuccess>
                        <p v-if="this.bookingDateItem.immediatelyYn === 'Y'">즉시 발송하였습니다.</p>
                        <p v-else>일정이 변경되었습니다</p>
                    </div>
                    <table class="key-value value-right">
                        <tr>
                            <th>캠페인명</th>
                            <td>{{this.bookingDateItem.corpEventName}}</td>
                        </tr>
                        <tr>
                            <th v-if="this.bookingDateItem.immediatelyYn === '즉시발송'">발송일시</th>
                            <th v-else>예약일시</th>
                            <td>{{convertedBookingDateToView}}</td>
                        </tr>
                    </table>
                    <div class="btns">
                        <button type="button" @click.prevent="completeChangeBooking" class="btn-l btn-p">완료</button>
                    </div>
                </div>
            </template>

            <!-- PC 팝업 닫기 아이콘 -->
            <button type="button" @click.prevent="closeBookingController('desktopClose')" class="position-absolute i-x tablet-none" aria-label="일정변경창 닫기">
                <IconClose />
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { eventBus } from '@/event/index.js';
import { transformDateFormat } from '@/util';

export default {
    components: {
        ShippingDateOption: () => import('@/components/order-item/ShippingDateOption.vue'),  // 발송일시 선택 컴포넌트
        IconClose: () => import('@/components/svg-icon/IconClose.vue'),                         // 팝업닫기 아이콘
        IconSuccess: () => import('@/components/svg-icon/IconSuccess.vue'),                     // 완료 아이콘
    },

    data() {
        return {
            // visibleBookingLayerPopup : false,               // 발송예약 일정변경 컴포넌트 숨김노출 여부
            checkedWhen: '즉시발송',
            viewEdit: true,
            datetimeLocal: null,                            // 예약발송 기본 세팅 현재 날짜
            datetimeLocalFormat: null,
            immediatelyYn: '',
            resultBookingDate: '',
            bookingDateItem:{} ,
            convertedBookingDateToView:'' ,
            isChangeBookingDate: false,                     // 예약일정 값의 변화 여부 확인
            showBookingCalendar: false,                     // 예약일정 값 캘린더 노출 여부
            // isDisabled: true                                // 변경 버튼 비활성화 상태
        }
    },

    computed: {
		...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
            authentication: state => state.authentication,
            vuexSendId: state => state.vuexSendId,
            visibleBookingLayerPopup: state => state.modalStore.modalsObj.visibleBookingLayerPopup,
        }),	
	},
    
    mounted() {
        eventBus.$off('shippingDate');  // 이벤트버스 중복호출 방지
        eventBus.$on('shippingDate', this.isShippingDate.bind(this)); // 발송 일시 선택값

        this.controlBodyScroll();
    },

    watch: {
        visibleBookingLayerPopup(){
            this.controlBodyScroll();
        }
    },

    methods: {
        checkClickedDatetimeLocal(){
            this.showBookingCalendar = true;
        },

        // 토스트팝업 외부영역 클릭 시 모바일 토스트 팝업 닫기
        closeBookingController(element) {

            // PC 화면 검은 배경 클릭시 처리
            if(element === 'mobileClose' && window.innerWidth >= 1200){
                // 날짜 인풋 캘린더를 열어서 클릭했다면 검은 배경화면 클릭시 창닫기 무효화
                if(this.showBookingCalendar === true){ 
                    this.showBookingCalendar = false; // 클릭 기준 초기화
                    return;
                }
            }
            this.$store.commit('modalStore/setVisibleBookingLayerPopup', false);
            this.viewEdit = true; // 다시 편집 화면 보이도록 초기화
        },

        // 이중스크롤 제어
        controlBodyScroll(){
            if(this.visibleBookingLayerPopup){
                this.$store.commit('modalStore/bodyScrollHandler');
            }else{
                this.$store.commit('modalStore/restoreBodyScroll');
            }
        },

        completeChangeBooking(){
            // 예약발송일이 변경되면 창을 닫을 때 페이지 새로고침
            if(this.isChangeBookingDate){
                location.reload();
            }else{
                this.closeBookingController();
            }
        },

        // 받아온 발송일시 선택값
        isShippingDate(value){
            this.checkedWhen = value; // 컨트롤러에서 받은 checkedWhen 값            
        },

        // 일정 변경 적용
        changeTheSchedule(){            
            // 발송타입 형식 변경
            this.convertImmediatelyVal();
            // 예약발송일 형식 변경
            this.convertBookingDateTypeToServer();

            if(this.immediatelyYn === 'N') {
                this.viewEdit = false; // 편집화면 숨김
                this.changeBookingDate();
            } else {
                let result = confirm('지금 바로 쿠폰이 발송됩니다. 진행하시겠습니까?');
                if(result) {
                    this.viewEdit = false;
                    this.changeBookingDate();
                }
            }
        },

        convertImmediatelyVal() {
            if(this.checkedWhen === '즉시발송') {
                this.immediatelyYn = 'Y'
            } else {
                this.immediatelyYn = 'N'
            }
        },

        convertBookingDateTypeToServer() {
            if(this.immediatelyYn === 'Y') { // 즉시발송일 경우
                this.resultBookingDate = '';
            } else {
                let year = this.datetimeLocal.substring(0, 4)
                let month = this.datetimeLocal.substring(5, 7)
                let day = this.datetimeLocal.substring(8, 10)
                let hour = this.datetimeLocal.substring(11, 13)
                let min = this.datetimeLocal.substring(14, 16)
                let date = new Date();
                let seconds = date.getSeconds();
                seconds = seconds < 10 ? '0' + seconds.toString() : seconds.toString();
                
                this.resultBookingDate = year + month + day + hour + min + seconds;
            }
        },

        changeBookingDate() {
            this.dispatchChangeBookingDate();
        },

        async dispatchChangeBookingDate() {
            try {
                const data = {
                    sendId: this.vuexSendId ,
                    bookingDate : this.resultBookingDate,
                    immediatelyYn : this.immediatelyYn,
                    userNo:this.userNo 
                }
                const response = await this.$store.dispatch(
                    'orderHistoryStore/actionsUpdateOrderHistoryShippingDateApi', 
                    data
                );

                this.isChangeBookingDate = true;
                this.bookingDateItem = response.data;
                this.convertedBookingDateToView = transformDateFormat(
                    response.data.bookingDate, 
                    response.data.bookingWeekend
                );

            } catch(err) {
                alert(err.response.data.message);
                return;
            }
        },

        setCheckedWhen(checkedWhen) {
            this.checkedWhen = checkedWhen;
        },

        setDatetimeLocal(datetimeLocal) {
            this.datetimeLocal = datetimeLocal;
        }
    },
}
</script>


<style lang="scss" scoped>

// @import '@/assets/css/orderhistory.scss';
@import '@/assets/css/order.scss';

</style>